@if (!isHidden) {
    @let tooltip = slot() | slotTooltip;
    @let title = slot().titleKey | translationKey: slot().titleData;
    <div class="flex items-start">
        <mat-form-field
            appearance="outline"
            subscriptSizing="dynamic"
            floatLabel="always"
            class="ca-form-field ca-form-field-m ca-form-field-w-full with-label with-error-message"
        >
            @if (title) {
                <mat-label>{{ title }}</mat-label>
            }
            <input
                matInput
                [formControl]="control"
                [placeholder]="(slot().placeholderKey | translationKey: slot().placeholderData) || ''"
                [disabled]="!!isDisabled"
                [required]="!slot().isOptional"
                [matAutocomplete]="auto"
                (input)="onInput($event)"
            />
            <ca-icon matSuffix icon="chevron-down" class="ca-icon-s-16-p-0-f-16 arrow-transition" [class.rotate]="isOpened"></ca-icon>
            <mat-autocomplete
                #auto="matAutocomplete"
                class="ca-dropdown-panel-class"
                (optionSelected)="onOptionSelected($event)"
                autoActiveFirstOption
                (opened)="isOpened = true"
                (closed)="isOpened = false"
            >
                @for (city of cities; track city.postalCode + city.city) {
                    <mat-option [value]="city">
                        {{ formatCity(city) }}
                    </mat-option>
                }
                @if (!cities.length && !loading) {
                    <mat-option>
                        {{ 'SLOT_ADDRESS_AUTOCOMPLETE_INPUT.NO_RESULTS' | translate }}
                    </mat-option>
                }
            </mat-autocomplete>
            @if (isErrorMessage) {
                <mat-error>
                    <ca-form-error-message>
                        {{ errorMessageTranslation!.key | translationKey: errorMessageTranslation!.data }}
                    </ca-form-error-message>
                </mat-error>
            }
        </mat-form-field>
        @if (tooltip) {
            <div class="flex items-center ms-2 pt-9">
                <ca-visual [tooltip]="tooltip"></ca-visual>
            </div>
        } @else if (isVisual) {
            <div class="flex items-center ms-2 pt-9">
                <ca-visual [slot]="slot()" [iconSize]="24"></ca-visual>
            </div>
        }
    </div>
}
